import React from "react";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";

import SecondarySelect from "../../custom-select/secondary-select";
import MaskedInput from "../../custom-input/masked-input";
import OutlinedTextInput from "../../custom-input/outlined-text-input";
import CustomSearchDropdown from "../../multi-select-dropdown";

const RenderField = ({
	field,
	fieldId,
	formState,
	updateField,
	errors,
	setErrors,
	submitted,
}) => {
	const fieldError = submitted && errors[field.name];

	const clearError = () => {
		if (errors[field.name]) {
			setErrors((prev) => ({ ...prev, [field.name]: "" }));
		}
	};

	switch (field.component) {
		case "select":
			const resolvedOptions =
				typeof field.options === "function"
					? field.options(formState)
					: field.options;

			return (
				<SecondarySelect
					id={fieldId}
					value={formState[field.name]}
					options={Array.isArray(resolvedOptions) ? resolvedOptions : []}
					handleChange={(e) => {
						updateField(field.name)(e);
						clearError();
					}}
					disabled={
						typeof field.disabled === "function"
							? field.disabled(formState)
							: field.disabled || false
					}
					error={Boolean(fieldError)}
					helperText={fieldError}
				/>
			);

		case "masked":
			return (
				<MaskedInput
					id={fieldId}
					type={field.maskType}
					placeholder={field.placeholder}
					value={formState[field.name]}
					onInputChange={(e) => {
						updateField(field.name)(e);
						clearError();
					}}
					disabled={
						typeof field.disabled === "function"
							? field.disabled(formState)
							: field.disabled || false
					}
					error={Boolean(fieldError)}
					helperText={fieldError}
				/>
			);

		case "numeric":
			return (
				<OutlinedTextInput
					id={fieldId}
					variant="outlined"
					type={field.type || "text"}
					placeholder={field.placeholder || ""}
					inputProps={{
						inputMode: "numeric",
						pattern: "[0-9]*",
						min: field.min,
						max: field.max,
						maxLength: field.maxLength,
					}}
					value={formState[field.name]}
					handleChange={(e) => {
						const value = e.target.value;
						if (!/^\d*$/.test(value)) return;

						updateField(field.name)(e);
						clearError();
					}}
					disabled={
						typeof field.disabled === "function"
							? field.disabled(formState)
							: field.disabled || false
					}
					error={Boolean(fieldError)}
					helperText={fieldError}
				/>
			);

		case "input":
			return (
				<OutlinedTextInput
					id={fieldId}
					variant="outlined"
					placeholder={field.placeholder}
					type={field.type}
					value={formState[field.name]}
					inputProps={{
						maxLength: field.maxLength ?? undefined,
					}}
					handleChange={(e) => {
						updateField(field.name)(e);
						clearError();
					}}
					disabled={
						typeof field.disabled === "function"
							? field.disabled(formState)
							: field.disabled || false
					}
					error={Boolean(fieldError)}
					helperText={fieldError}
				/>
			);

		case "autocomplete-multi":
			return (
				<CustomSearchDropdown
					options={field.options}
					value={formState[field.name]}
					disabled={
						typeof field.disabled === "function"
							? field.disabled(formState)
							: field.disabled || false
					}
					error={Boolean(fieldError)}
					helperText={fieldError}
					onChange={(e) => {
						updateField(field.name)(e);
						clearError();
					}}
					variant="outlined"
					showEndIcon
					endIcon={
						<KeyboardArrowDownIcon
							sx={{
								fontSize: 20,
								color: "action.active",
								pointerEvents: "none",
							}}
						/>
					}
				/>
			);

		default:
			return null;
	}
};

export default RenderField;
